import { render, staticRenderFns } from "./FiltroPesquisaAReceber.vue?vue&type=template&id=6c40961e&scoped=true"
import script from "./FiltroPesquisaAReceber.vue?vue&type=script&lang=js"
export * from "./FiltroPesquisaAReceber.vue?vue&type=script&lang=js"
import style0 from "./FiltroPesquisaAReceber.vue?vue&type=style&index=0&id=6c40961e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40961e",
  null
  
)

export default component.exports